import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';

var _excluded = ["values", "unit", "step"];
// const muiBreakpoint: BreakpointValues = {
//   xs: 0,
//   sm: 600,
//   md: 960,
//   lg: 1280,
//   xl: 1920
// }

// const defaultBreakpoint: BreakpointValues<BreakpointDefaults> = {
//   xxs: 420, // majority mobile portraits (widest portrait iPhone 8)
//   xs: 600,
//   sm: 900, // majority tablet portraits
//   md: 1024, // secondary break between portrait/landscape of high resolution tablets
//   lg: 1366, // high resolution tablets landscape
//   xl: 1440, // point of reference: MacBook Air 13 inch, Microsoft Surface Pro 3 (portrait)
//   xxl: 1700
// }

var defaultBreakpoint = {
  xxs: 420,
  // majority mobile portraits (widest portrait iPhone 8)
  xs: 600,
  sm: 900,
  // majority tablet portraits
  md: 1025,
  // secondary break between portrait/landscape of high resolution tablets - 1 px added to prevent collision with desktop first tailwind-css used in Lender
  lg: 1281,
  // 1 px added to prevent collision with desktop first tailwind-css used in Lender
  xl: 1441,
  // point of reference: MacBook Air 13 inch, Microsoft Surface Pro 3 (portrait) - 1 px added to prevent collision with desktop first tailwind-css used in Lender
  xxl: 1601 // 1 px added to prevent collision with desktop first tailwind-css used in Lender
};

// Keep in mind that @media is inclusive by the CSS specification.
var createBreakpoints = function createBreakpoints(options) {
  var _ref = options || {},
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? defaultBreakpoint : _ref$values,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? 'px' : _ref$unit,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 5 : _ref$step,
    other = _objectWithoutProperties(_ref, _excluded);
  var keys = Object.keys(values);
  var width = function width(key) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return values[key];
  };
  var up = function up(key) {
    var value = typeof key === 'string' && typeof width(key) === 'number' ? width(key) : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  };
  var down = function down(key) {
    var endIndex = typeof key === 'string' ? keys.indexOf(key) + 1 : key;
    var upperBound = endIndex === 0 ? width(keys[0]) : typeof key === 'string' && endIndex < keys.length ? width(keys[endIndex]) : endIndex;
    if (typeof key === 'string' && endIndex > keys.length - 1) {
      // down from the biggest breakpoint applies to all sizes
      return up(0);
    }
    var value = typeof upperBound === 'number' && endIndex > -1 ? upperBound : key;
    var delta = step / 100;
    return "@media (max-width:".concat(value - delta).concat(unit, ")");
  };
  var between = function between(start, end) {
    var endIndex = typeof end === 'string' ? keys.indexOf(end) : end;
    if (endIndex === keys.length - 1) {
      return up(start);
    }
    var delta = step / 100;
    return "@media (min-width:".concat(typeof start === 'string' && typeof width(start) === 'number' ? width(start) : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof width(keys[endIndex + 1]) === 'number' ? width(keys[endIndex + 1]) : end) - delta).concat(unit, ")");
  };
  var only = function only(key) {
    return between(key, key);
  };
  var map = function map() {
    return keys.map(function (i) {
      return up(i);
    });
  };
  var getValueAndUnit = function getValueAndUnit(key) {
    return key && width(key) ? "".concat(width(key)).concat(unit) : undefined;
  };
  var scaleToSize = function scaleToSize(scale) {
    return function (_width) {
      var scaleKeys = Object.keys(scale);
      if (scaleKeys.length === 0) {
        throw new Error('invalid scale');
      }
      if (_width === undefined || _width === null) {
        return scale[scaleKeys[Math.floor(scaleKeys.length / 2)]];
      }
      var breakpoint = scaleKeys[0];
      keys.some(function (i) {
        if (scaleKeys.includes(i)) {
          breakpoint = i;
        }
        return width(i) >= _width;
      });
      return scale[breakpoint];
    };
  };
  return _objectSpread2({
    keys: keys,
    // @ts-ignore
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width,
    map: map,
    getValueAndUnit: getValueAndUnit,
    scaleToSize: scaleToSize
  }, other);
};
var defaultBreakpoints = createBreakpoints();

export default createBreakpoints;
export { defaultBreakpoints };
//# sourceMappingURL=breakpoints.esm.js.map
